import React, { Fragment } from 'react';
import { object, number } from 'prop-types';
import styled from 'styled-components';

import withVisibilityToggle from '../../../../../core/enhancements/withVisibilityToggle';
import VisibilityInformation from '../../VisibilityInformation';
import CheckoutButton from '../../CheckoutButtonContainer';
import Characteristics from '../../CharacteristicsContainer';
import DiscountTag from '../../DiscountTagContainer';
import Price from '../../Price';
import InstallmentPrice from '../../InstallmentPrice';
import FreeRenewalMessage from '../../FreeRenewalMessage';

const DiscountLabel = withVisibilityToggle(DiscountTag);

const InfoContainer = styled.div`
  background: #fff;
  @media(max-width: 320px) {
    padding: 15px 15px;
  }
  padding: 15px 19px;
  margin: 0 10px;
  border-radius: 8px;
  border: solid 1px #e5e5e5;
  max-width: 288px;
  margin: 12px auto;
  position: relative;
`;

const InfoTitle = styled.div`
  font-weight: bold;
  font-size: 18px;
  text-transform: uppercase;
  margin-top: 10px;
  margin-bottom: 8px;
`;

const CheckoutButtonWrapper = styled.div`
  padding: 12px 20px;
`;

const ProductPickerInfo = ({ product, categoryBalance }) => {
  if (!Object.keys(product).length) return <div />;

  const {
    fullName,
    amount,
    totalPrice: price,
    characteristics,
    totalReferencePrice: referencePrice,
    visibility,
    discount,
    type,
    installment,
    message
  } = product;

  const isDiamond = type === 'PACKAGE_DIAMOND';
  const hasInstallmentToShow = typeof installment === 'object';

  const newCharacteristics = [
    ...characteristics,
    {
      checkmark: isDiamond,
      link: 'superShowcase',
      text: isDiamond ? '7 dias com Super Vitrine *NOVO*' : '~~7 dias com Super Vitrine~~ *NOVO*',
      visualHighlight: true,
    },
  ];

  if (isDiamond) {
    newCharacteristics[1] = {
      ...newCharacteristics[1],
      text: '7 dias com o selo **Super Vitrine**',
    };
  }

  return (
    <InfoContainer>
      <InfoTitle>{fullName}</InfoTitle>
      <DiscountLabel
        showIf={discount}
        discount={discount}
        product={product}
      />

      {message
        ? <FreeRenewalMessage message={message} availableLimit={categoryBalance} />
        : <VisibilityInformation text={visibility.text} margin="5px 0px 8px 0px" fontSize="14px" />
      }

      {!message && <Fragment>
        <Price value={price} posDiscount={discount} visible={!hasInstallmentToShow} />
        {hasInstallmentToShow && <InstallmentPrice value={price} posDiscount={discount} installment={installment} />}
      </Fragment>}

      <CheckoutButtonWrapper>
        <CheckoutButton big product={product} />
      </CheckoutButtonWrapper>
      <Characteristics
        characteristics={characteristics}
        price={price}
        amount={amount}
        referencePrice={referencePrice}
        noToggle
      />
    </InfoContainer>
  );
};

ProductPickerInfo.propTypes = {
  product: object,
  categoryBalance: number,
};

ProductPickerInfo.defaultProps = {
  product: {},
  categoryBalance: 0,
};

export default ProductPickerInfo;
